import { paths } from 'src/routes/paths';

// Moduli dell'azienda: spenti solo se valgono false, così una sessione
// senza il campo vede la webapp come prima.
export function isModuleEnabled(company, flag) {
  return company?.[flag] !== false;
}

// Prima pagina disponibile: evita redirect circolari quando calendario,
// avvisi o documenti sono spenti.
export function getLandingPath(user) {
  const company = user?.data?.company;
  if (user?.data?.has_timesheet !== false && company?.feature_employee_calendar !== false) {
    return paths.dashboard.root;
  }
  if (isModuleEnabled(company, 'feature_communications')) return paths.dashboard.notices;
  if (isModuleEnabled(company, 'feature_documents')) return paths.dashboard.documents;
  return paths.dashboard.profile;
}
